import { Card } from '@/components/ui/card';
import { formatDate, getFutureAge } from '@/utils/date';
import { PartyPopper } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ListSaved } from '../list';

type ListSavedCardProps = {
	savedList: ListSaved;
	onClick?: () => void;
};

const ListSavedCard = ({ savedList, onClick }: ListSavedCardProps) => {
	const { t } = useTranslation();
	return (
		<Card
			key={savedList.id}
			onClick={() => onClick?.()}
			className="flex cursor-pointer items-center justify-between gap-4 rounded-md border border-gray-200 px-4 py-3 dark:border-gray-800 sm:max-w-md"
		>
			<div className="flex items-center gap-4">
				<div className="px-1">
					<PartyPopper className="h-6 w-6 text-gray-500 dark:text-gray-400" />
				</div>
				<div>
					<h4 className="text-sm font-medium">
						{savedList.user.firstname} {savedList.user.lastname}
					</h4>
					<p className="text-sm text-gray-500 dark:text-gray-400">
						{savedList.name}
					</p>
					<p className="text-sm text-gray-500 dark:text-gray-400">
						{formatDate(savedList.user.birthday || '')}
					</p>
				</div>
			</div>
			<div className="pr-4 text-center leading-5">
				<p>{getFutureAge(savedList.user.birthday || '')}</p>
				<p>{t('listSaved.age.suffix')}</p>
			</div>
		</Card>
	);
};

export default ListSavedCard;
